$bog_music_track $mol_view
	key \
	current false
	play? null
	archive_mode false
	can_drag false
	drag_start? null
	drop_here? null
	archive? null
	restore? null
	delete_forever? null
	demote? null
	share_selected false
	cover \
	attr *
		bog_music_track_current <= current
		bog_music_track_share_selected <= share_selected
		bog_music_track_pending <= blob_pending false
		draggable <= can_drag
	event *
		dragstart?event <=> event_drag_start?event null
		dragover?event <=> event_drag_over?event null
		drop?event <=> event_drop?event null
	sub <= content /
		<= Cover_box $mol_view
			event *
				click?event <=> on_play_click? null
			sub /
				<= Cover $mol_image
					uri <= cover
				<= Cover_placeholder $mol_icon_music
		<= Info $mol_view
			event *
				click?event <=> on_play_click?
			sub /
				<= Title $mol_paragraph
					title <= title \
				<= Artist $mol_paragraph
					title <= artist \
		<= Share $mol_view
			attr *
				bog_music_track_share_button true
				bog_music_track_share_selected <= share_selected
			event *
				pointerdown?event <=> share_pointer_down?event null
				pointerup?event <=> share_pointer_up?event null
				pointercancel?event <=> share_pointer_cancel?event null
				pointerleave?event <=> share_pointer_leave?event null
			sub /
				<= Share_icon $mol_icon_share
		<= Menu $mol_pop
			Anchor <= Menu_anchor $mol_button_minor
				hint \Действия
				click? <=> menu_toggle? null
				sub /
					<= Menu_icon $mol_icon_dots_vertical
			bubble_content /
				<= Menu_panel $mol_view
					sub <= menu_items /
						<= Demote $mol_button_minor
							click? <=> demote_click? null
							sub /
								<= Demote_icon $mol_icon_format_vertical_align_bottom
								<= Demote_label $mol_view
									sub / \В конец списка
						<= Pull $mol_button_minor
							click? <=> pull_click? null
							sub /
								<= Pull_icon $mol_icon_download
								<= Pull_label $mol_view
									sub / <= pull_label \
						<= Delete $mol_button_minor
							click? <=> delete_cached? null
							sub /
								<= Delete_icon $mol_icon_delete
								<= Delete_label $mol_view
									sub / \Убрать с устройства
						<= Archive $mol_button_minor
							click? <=> archive_click? null
							sub /
								<= Archive_icon $mol_icon_archive
								<= Archive_label $mol_view
									sub / \В архив
						<= Move*0 $mol_button_minor
							click? <=> move_click*? null
							sub <= move_content* /
								<= Move_add_icon* $mol_icon_playlist_plus
								<= Move_cut_icon* $mol_icon_playlist_remove
								<= Move_label* $mol_view
									sub / <= move_label* \
						<= Restore $mol_button_minor
							click? <=> restore_click? null
							sub /
								<= Restore_icon $mol_icon_restore
								<= Restore_label $mol_view
									sub / \Восстановить
						<= Delete_forever $mol_button_minor
							click? <=> delete_ask? null
							sub /
								<= Delete_forever_icon $mol_icon_delete_forever
								<= Delete_forever_label $mol_view
									sub / \Удалить навсегда
	Confirm $mol_view
		sub /
			<= Confirm_text $mol_paragraph
				title <= confirm_text \
			<= Confirm_actions $mol_view
				sub /
					<= Confirm_no $mol_button_minor
						title \Отмена
						click? <=> delete_cancel? null
					<= Confirm_yes $mol_button_major
						title \Удалить
						click? <=> delete_confirm? null
